import { CapoPlugin } from "/var/www/msn-form-inscripcion-web/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];